/**
 * @param {any} draft - Draft state.
 * @param {any} payload - Action payload.
 */
export const removeRequest = ( draft, payload ) => {
    draft.requests = draft.requests.filter( req => !_.isEqual( req, payload ) );
};